/**
 * 業界ソリューションページ翻訳 - 日本語
 * Industry Solutions page translations - Japanese
 */

export default {
  hero: {
    title: '業界ソリューション',
    subtitle: '金融、製造、小売、プロフェッショナルサービス、医療、政府などの業界に向けて、業務に即したデジタルおよびインテリジェントソリューションを提供します',
    imageAlt: '業界ソリューション背景画像'
  },
  
  overview: {
    title: '製品概要'
  },
  
  industries: {
    finance: {
      title: '金融業界ソリューション',
      imageAlt: '金融業界ソリューション',
      painPoints: {
        title: '課題',
        content: 'サイバーセキュリティ脅威、厳格なコンプライアンス、老朽化した基幹システム、顧客体験への期待の高まり'
      },
      solution: {
        title: 'ソリューション',
        content: '金融クラウド、統合規制報告、マネージドセキュリティ、オムニチャネル顧客基盤を組み合わせ、安全で俊敏な金融デジタル基盤を構築'
      },
      results: {
        title: '実装効果',
        content: '基幹システムの近代化と報告自動化を支え、リリース速度と顧客対応の一貫性を向上'
      }
    },
    
    ticketAi: {
      title: 'スマートチケット&AI分析プラットフォーム',
      imageAlt: 'スマートチケット&AI分析プラットフォーム',
      ticketSystem: {
        title: 'スマートチケットシステム',
        features: [
          'チケットの自動作成、割り当て、優先順位付け',
          'マルチチャネルアクセス（メール、電話、チャット、API）',
          'SLA管理とリアルタイム監視ダッシュボード',
          'カスタムワークフローとビジネスルールエンジン',
          'ナレッジベース統合と自動返信提案'
        ]
      },
      aiAnalytics: {
        title: 'AIインテリジェント分析&データ統合',
        features: [
          '自然言語処理技術でチケット内容を解析',
          '予測分析で潜在的な問題とトレンドを識別',
          'マルチソースデータ統合と可視化レポート',
          'カスタムKPI監視と異常アラート',
          'オープンAPIとサードパーティシステムのシームレスな統合'
        ]
      },
      results: {
        title: '実装効果',
        content: 'チケット処理効率65%向上、人的エラー40%削減、顧客満足度35%向上、運用コスト28%削減'
      }
    },
    
    manufacturing: {
      title: '製造業界ソリューション',
      imageAlt: '製造業界ソリューション',
      painPoints: {
        title: '課題',
        content: 'サプライチェーンの分断、生産効率の低さ、設備停止、品質変動、データサイロ'
      },
      solution: {
        title: 'ソリューション',
        content: '産業 IoT、MES と ERP の統合、サプライチェーン可視化、現場デジタルツインを軸に、スマートファクトリーとデジタルサプライチェーンを構築'
      },
      results: {
        title: '実装効果',
        content: '生産の見える化とトレーサビリティを高め、停止リスクを抑えながら拠点間サプライチェーン連携を強化'
      }
    },

    retail: {
      title: '小売業界ソリューション',
      imageAlt: '小売業界ソリューション',
      painPoints: {
        title: '課題',
        content: '多国・多店舗の依頼が分散し、店舗ネットワーク、POS、端末障害が営業に影響。現地対応力や開店・移転プロセスも統一しにくい'
      },
      solution: {
        title: 'ソリューション',
        content: 'APAC をカバーする店舗 IT サポートとして、統一サービスデスク、現地エンジニアネットワーク、店舗 IT ライフサイクル管理、標準化されたデータ運用を提供'
      },
      results: {
        title: '実装効果',
        content: '数百店舗の依頼を集中管理し、応答速度とサービス統制を高め、安定・効率的で追跡可能な店舗 IT 運用体制を構築'
      }
    },
    
    healthcare: {
      title: '医療業界ソリューション',
      imageAlt: '医療業界ソリューション',
      painPoints: {
        title: '課題',
        content: '医療データプライバシー保護、機関間のデータ共有の困難、遠隔医療システムの安定性要件'
      },
      solution: {
        title: 'ソリューション',
        content: '安全で制御可能な医療データストレージと交換プラットフォーム、プライバシー保護法規に準拠したシステムアーキテクチャ'
      },
      results: {
        title: '実装効果',
        content: 'データ交換効率60%向上、患者情報セキュリティコンプライアンス率100%、遠隔診療システム安定性99.9%'
      }
    },
    
    government: {
      title: '政府&公共事業ソリューション',
      imageAlt: '政府&公共事業ソリューション',
      painPoints: {
        title: '課題',
        content: '電子政府システムの高い安定性要件、厳格なデータセキュリティ保護ニーズ、部門間協業効率の低さ'
      },
      solution: {
        title: 'ソリューション',
        content: '高信頼性ITインフラとセキュリティ保護システムで、複数部門のデータ共有とビジネス協業をサポート'
      },
      results: {
        title: '実装効果',
        content: 'システム障害率45%削減、部門間ビジネス処理効率50%向上、データセキュリティコンプライアンス率100%'
      }
    }
  },

  focusIndustries: {
    title: '業界別ソリューション',
    subtitle: '金融、製造、小売、医療、政府、スマートチケットと AI 分析の 6 つの主要シーンに沿って、より要件に近い業界別ソリューションを整理しました。',
    keySolutionLabel: '主要ソリューション',
    painPointsTitle: '業界課題',
    solutionTitle: 'ソリューション構成',
    outcomeTitle: '提供価値',
    items: [
      {
        title: '製造業',
        keySolution: 'スマートファクトリーとデジタルサプライチェーン',
        painPoints: 'サプライチェーンの分断、生産効率の低下、設備停止、品質のばらつき、データサイロ。',
        solutions: [
          '産業 IoT プラットフォーム: センサーで機械や生産ラインを接続し、リアルタイムデータ収集、予知保全、エネルギー管理を実現して突発停止を削減します。',
          'MES 統合: MES と ERP を統合し、受注から完成品までの生産プロセスをデジタル化・可視化して、効率とトレーサビリティを向上させます。',
          'デジタルサプライチェーンダッシュボード: サプライヤー管理、在庫最適化、物流追跡を一元可視化する統合データ基盤を構築します。',
          '現場デジタルツイン: 生産ラインの仮想モデルを作成し、シミュレーション、工程最適化、立ち上げ、教育に活用します。'
        ],
        outcome: '設備接続、工程連携、サプライチェーン可視化を通じて、計画外停止を抑え、品質追跡と拠点横断の連携を強化します。'
      },
      {
        title: '金融サービス',
        keySolution: '安全・コンプライアンス・デジタル顧客体験',
        painPoints: 'サイバーセキュリティ脅威、厳格な規制、旧式な基幹システム、顧客体験への高い期待。',
        solutions: [
          '金融クラウドと基幹システム近代化: 銀行・保険の基幹システムを金融クラウドへ安全に移行し、可用性、俊敏性、開発速度を向上させます。',
          '統合規制報告プラットフォーム: PBOC や CBIRC などへの報告に対応できる自動化データ基盤を整備します。',
          '金融向けマネージドセキュリティサービス: 24 時間 365 日の監視、脅威インテリジェンス、インシデント対応で顧客データと取引を保護します。',
          'オムニチャネルバンキング基盤: モバイル、オンライン、店舗チャネルを統合し、一貫したパーソナライズ体験を提供します。'
        ],
        outcome: 'クラウド近代化、コンプライアンス自動化、マネージドセキュリティを通じて、運用レジリエンス、監査性、顧客接点品質を高めます。'
      },
      {
        title: '小売業界',
        keySolution: '多国展開店舗 IT 運用ソリューション',
        painPoints: '多国・多店舗で依頼窓口が分散し、機器やネットワーク障害が営業に影響。開店、移転、閉店の標準プロセスと現地対応力にばらつきがあります。',
        solutions: [
          '統一サービスデスク: すべての店舗 IT 依頼を集中受付、振り分け、SLA 追跡、エスカレーション、クローズ管理します。',
          '現地エンジニアネットワーク: APAC 主要地域をカバーし、遠隔診断と現地対応で店舗ネットワーク、POS、端末、周辺機器を迅速に支援します。',
          '店舗 IT ライフサイクル管理: 新店開業、日常運用、移転、改装、閉店回収まで標準チェックリストで支援します。',
          '標準化とデータ運用: 店舗資産、サービス履歴、障害種別、応答データを蓄積し、運用ダッシュボードと継続改善に活用します。'
        ],
        outcome: '数百店舗を効率的に管理し、営業影響を抑えながら、安定・高効率・統制可能な店舗 IT 運用体系を構築します。'
      },
      {
        title: '医療業界',
        keySolution: '安全でコンプライアンスに適合した医療データ保存・交換',
        painPoints: '医療データのプライバシー保護要件が高く、機関間データ共有が難しく、遠隔医療システムには高い安定性が求められます。',
        solutions: [
          '医療データ保存・交換基盤: 安全なデータ交換経路を構築し、機関間協業と情報共有を支援します。',
          'プライバシー保護と権限管理: 役割、機関、業務シーンに応じたアクセス制御、監査証跡、データマスキングを設計します。',
          '遠隔医療の安定性確保: ネットワーク、端末、アプリ、監視を含めた可用性向上を支援します。',
          'コンプライアンス対応アーキテクチャ: 医療データ保護要件に沿ったシステム構成と運用プロセスを設計します。'
        ],
        outcome: '医療データ交換効率と遠隔診療の安定性を高め、患者情報の安全性とコンプライアンスを確保します。'
      },
      {
        title: '政府・公共事業',
        keySolution: '高信頼 IT インフラとセキュリティ保護体系',
        painPoints: '電子政府システムには高い安定性が求められ、データセキュリティ要件が厳しく、部門間のデータ共有と業務連携に課題があります。',
        solutions: [
          '高信頼インフラ: 重要な公共システムの継続稼働を支える計算、ネットワーク、ストレージ、災害対策能力を構築します。',
          'データセキュリティ保護: ID 認証、アクセス制御、セキュリティ監視、ログ監査、インシデント対応をカバーします。',
          '部門横断データ共有: データ標準、API 仕様、共有フローを統一し、複数部門の協業を支援します。',
          '運用とコンプライアンス管理: 点検、監視、障害対応、セキュリティコンプライアンスの閉ループを構築します。'
        ],
        outcome: 'システム障害率を下げ、部門間処理効率とデータセキュリティコンプライアンスを高め、公共サービスの安定運用を支援します。'
      },
      {
        title: 'スマートチケットと AI 分析',
        keySolution: '自動化サービス管理とインテリジェント運用分析',
        painPoints: 'サービス依頼チャネルが分散し、手動振り分けの効率が低く、SLA 監視、傾向予測、多ソース分析が不足しています。',
        solutions: [
          'スマートチケットシステム: チケット自動作成、割り当て、優先順位付け、マルチチャネル受付、SLA 管理、カスタムワークフローを支援します。',
          'ナレッジベースと自動返信提案: FAQ、SOP、過去チケット経験を処理フローに接続します。',
          'AI 分析: NLP でチケット内容を解析し、予測分析で潜在問題、傾向、異常を検出します。',
          'データ統合と可視化: 多ソースデータ、カスタム KPI、異常アラート、オープン API、外部システム連携を提供します。'
        ],
        outcome: 'チケット処理効率を高め、人的ミスを減らし、顧客満足度を向上させ、運用コストを削減します。'
      }
    ]
  },

  productMatrix: {
    title: '拡張プロダクトとデジタル機能',
    subtitle: 'スマートチケットおよび AI 分析プラットフォームに加えて、CRM、MA、ミニプログラム、AI ナレッジベース、オフィス向けインテリジェントエージェントも提供し、顧客運営、サービス、社内協業を支援します。',
    modulesTitle: '主要モジュール',
    scenariosTitle: '活用シーン',
    noteTitle: '段階導入に対応する柔軟な構成',
    note: 'これらの機能は単独導入も可能であり、Web サイト、CRM、ERP、チケットシステム、メール、社内業務フローとの連携にも対応します。既存システム、組織体制、業務フローに合わせて、実用的な導入計画を設計します。',
    action: 'ソリューションを相談する',
    items: [
      {
        title: 'CRM ソフトウェア開発',
        tagline: '会員基盤とC向けユーザー運営',
        description: 'ブランドの C 向けユーザー管理に対応する会員 CRM をカスタム開発し、会員プロフィール、セグメント、ポイント、クーポン、特典、接点運営、再購入分析を支援します。',
        modules: [
          '会員プロフィール、タグ、セグメント管理',
          'ポイント、クーポン、ランク、特典管理',
          '行動分析と再購入運営'
        ],
        scenarios: [
          'ブランド会員運営',
          'C向けユーザーへの精密接点',
          'キャンペーン成長と再購入向上'
        ]
      },
      {
        title: 'MA マーケティングオートメーション',
        tagline: '自動接点とコンバージョン拡大',
        description: 'Web フォーム、CRM、メール、SMS、企業 IM を接続し、リードスコアリング、自動セグメント、マーケティングジャーニー、成果計測までを一体化します。',
        modules: [
          'リードスコアリングとタグ管理',
          '自動ジャーニーとトリガーメッセージ',
          '施策効果のアトリビューションと分析'
        ],
        scenarios: [
          'Web リード育成',
          '展示会やイベント後のフォロー',
          '会員の再活性化とリピート施策'
        ]
      },
      {
        title: 'ミニプログラム開発',
        tagline: '軽量なサービス導線',
        description: '顧客対応、会員運営、予約申請、チケット照会、各種手続きなどの業務に向けて、ミニプログラム開発と管理画面連携を提供します。',
        modules: [
          'ログイン、会員管理、組織権限',
          'フォーム、チケット、メッセージセンター',
          'CRM、ERP、決済、API 連携'
        ],
        scenarios: [
          '顧客サービス窓口',
          '社内修理申請と承認',
          '会員サービスと予約受付'
        ]
      },
      {
        title: 'AI ナレッジベース',
        tagline: '知識蓄積とインテリジェント Q&A',
        description: 'FAQ、SOP、チケット対応ナレッジ、製品資料、社内文書を統合し、権限管理、多言語検索、対話型の知識提供を実現します。',
        modules: [
          '文書取り込みとバージョン管理',
          'セマンティック検索と回答生成',
          '権限制御とフィードバックループ'
        ],
        scenarios: [
          'カスタマーサポートの知識支援',
          '社内運用ナレッジ管理',
          '地域トレーニングとノウハウ再利用'
        ]
      },
      {
        title: 'オフィス向けインテリジェントエージェント',
        tagline: 'オフィス業務の自動化',
        description: 'メール、承認、会議メモ、タスク配分、日報週報、ナレッジ照会などの業務を対象に、企業システムへ接続可能なエージェント機能を構築します。',
        modules: [
          'メール、IM、カレンダー、文書連携',
          'フロートリガーとタスクオーケストレーション',
          'データ書き戻し、監査ログ、権限制御'
        ],
        scenarios: [
          '営業フォローの自動化',
          'サービス運営の協業',
          '管理会議とナレッジ Q&A'
        ]
      }
    ]
  },
  
  coreFeatures: {
    title: 'コア機能特徴',
    
    ticketManagement: {
      title: 'スマートチケット管理',
      description: 'チケットのライフサイクル全体を追跡し、作成から解決までの完全なプロセス管理をサポート、カスタムフィールドとステータスに対応。自動分類と優先順位付けで、チケット処理効率を最大65%向上。',
      benefits: [
        '自動ルーティング',
        'SLAタイマー',
        'バッチ操作',
        'チームコラボレーション'
      ]
    },
    
    dataAnalytics: {
      title: 'リアルタイムデータ分析',
      description: '直感的なデータ可視化ダッシュボードで主要業績指標をリアルタイム監視し、チームの迅速な意思決定をサポート。多次元データ表示により、異常識別速度が40%向上。',
      benefits: [
        'カスタムレポート',
        'トレンド分析',
        '部門比較',
        'エクスポート機能'
      ]
    },
    
    aiAssistant: {
      title: 'AIスマートアシスタント',
      description: '機械学習ベースのインテリジェント分析エンジンで、問題パターンを自動識別し、ソリューション提案を提供。自然言語処理技術により、チケット自動分類精度92%達成。',
      benefits: [
        '自動分類',
        '優先順位予測',
        'ソリューション推奨',
        '感情分析'
      ]
    },
    
    dataIntegration: {
      title: 'データ統合能力',
      description: '既存の企業システムとシームレスに接続し、データの双方向フローを実現、情報サイロを解消。200種類以上のAPI統合をサポート、データ同期遅延100ms未満。',
      benefits: [
        'APIインターフェース',
        'サードパーティ統合',
        'データ同期',
        'セキュリティ認証'
      ]
    }
  },
  
  cta: {
    title: '貴社の業界向けにカスタマイズされたインテリジェントソリューション',
    description: '当社のスマートチケットシステムとAI分析プラットフォームは、金融、製造、医療などの複数の業界で成功裏に適用され、企業の運用効率向上、コスト削減、データ駆動型意思決定を支援しています。お問い合わせいただき、専用コンサルティングサービスをご利用ください',
    button: '業界専用ソリューションを取得'
  }
}
